import React, { useState, useEffect } from "react";
import { CanEdit } from "@/shared/readOnlyManager";
import ResendIcon from "mdi-react/AccountPlusIcon";
import MailIcon from "mdi-react/MailOutlineIcon";
import ParticipantGoalPlans from "./ParticipantGoalPlans";
import ParticipantLockedInfo from "./ParticipantLockedInfo";
import ParticipantAddress from "./ParticipantAddress";
import PeerIcon from "mdi-react/PostItNoteAddIcon";
import AddressModal from "./AddressModal";
import axios from 'axios'
import { sendFlashMessage } from '@/redux/actions/flashActions'
import {flashDispatch, flashMessage } from '@/shared/helpers'
import ApiErrorMessage from "@/shared/components/flash/ApiErrorMessage"
import ModalWrapper from "./ModalWrapper";
import ParticipantCurrentPoints from "./ParticipantCurrentPoints";
import ParticipantInfo from "./ParticipantInfo";
import ParticipantRewardHistory from "./ParticipantRewardHistory";
import { Modal, Col, Row, Button, Container, ModalHeader, ModalBody } from "reactstrap";
import CloseIcon from "mdi-react/CloseIcon";

const ParticipantViewModal = ({ isOpen, setOpen, toggle, participants, program, template, setRefreshUsers }) => {
  const [participant, setParticipant] = useState([]);
  const [isActionOpen, setActionOpen] = useState(false);
  const [modalName, setModalName] = useState(null);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = flashDispatch();
  const toggle_modal = (name = null) => {
    if (typeof name === "string") {
      setModalName(name);
      setActionOpen(true);
      return;
    }

    setActionOpen(false);
    setModalName(null);
  };
  const onClickAction = (name, participant) => {
    setParticipant([participant]);
    toggle_modal(name);
  };
  const handleSave = (data) => {
      const user_id = participant?.id;
      if(user_id !==false) { 
        axios
        .post(`/users/${user_id}/addresses`, data)
        .then((res) => {
            if (res.status === 200) {
            dispatch(
                flashMessage(
                "Participant Address Added successfully!"
                )
            );
            //toggle();
            setLoading(false);
            setRefreshUsers(true);
            }
        })
        .catch((error) => {
            // return false;
            if (error?.response?.data) {
            dispatch(
                sendFlashMessage(
                <ApiErrorMessage errors={error.response.data} />,
                "alert-danger"
                )
            );
            setLoading(false);
            }
        });
      }
    };
  return (
    <Modal
      className={`modal-xl`}
      isOpen={isOpen}
      toggle={() => setOpen(true)}
    >
      <div className="close cursor-pointer">
        <CloseIcon onClick={toggle} size={30} />
      </div>
      <ModalHeader>
        <h3>Participant Information</h3>
      </ModalHeader>
      <ModalBody>  
        <Container fluid>
          <Col>
            <Button
              type="button"
              aria-label="button collapse"
              className="action-item template-button border-0 me-2"
              style={template.button_color ? {
                color: template.button_color,
                backgroundColor: template.button_bg_color,
              } : {}}
              onClick={(e) => {
                window.location.href = `mailto: ${participants.email}`;
                e.preventDefault();
              }}
              // onClick={handleToggleCollapse}
            >
              <div className="d-flex gap-1">
                <MailIcon />
                Email
              </div>
            </Button>
            <Button
              onClick={() => onClickAction("Resend Invite", participants)}
              type="button"
              aria-label="button collapse"
              className="action-item template-button border-0 me-2"
              style={template.button_color ? {
                color: template.button_color,
                backgroundColor: template.button_bg_color,
              } : {}}
            >
              <div className="d-flex gap-1">
                <ResendIcon />
                Resend Invite
              </div>
            </Button>
            <CanEdit>
              {!!program.uses_peer2peer && <Button
                onClick={() =>
                  onClickAction("Reclaim Peer Allocations", participants)
                }
                type="button"
                aria-label="button collapse"
                className="template-button border-0 me-2"
                style={template.button_color ? {
                  color: template.button_color,
                  backgroundColor: template.button_bg_color,
                } : {}}
              >
                <div className="d-flex gap-1">
                  <PeerIcon />
                  Reclaim Peer Allocations
                </div>
              </Button>}
              <Button
                type="button"
                aria-label="button collapse"
                className="action-item template-button border-0 me-2"
                style={template.button_color ? {
                  color: template.button_color,
                  backgroundColor: template.button_bg_color,
                } : {}}
                onClick={ () =>{
                  onClickAction("Edit Participant", participants)
                  }
                }
              >
                <div className="d-flex gap-1">
                  Edit Participant
                </div>
              </Button>
              <Button
                type="button"
                aria-label="button collapse"
                className="action-item template-button border-0 me-2"
                style={template.button_color ? {
                  color: template.button_color,
                  backgroundColor: template.button_bg_color,
                } : {}}
                 onClick={() => {
                      setModalOpen(true);
                      setParticipant(participants);
                  }}
              >
                <div className="d-flex gap-1">
                  Add Participant Address
                </div>
              </Button>
              {!participants.is_locked && <Button
                type="button"
                color="danger"
                aria-label="button collapse"
                className="action-item template-button border-0 me-2"
                style={template.button_color ? {
                  color: template.button_color,
                } : {}}
                 onClick={ () =>{
                  onClickAction("Lock Participant", participants)
                  }}
              >
                <div className="d-flex gap-1">
                  Lock Participant
                </div>
              </Button>}
            </CanEdit>
          </Col>
            {!!participants.is_locked && <Row className="mt-0 p-2" style={{border: "2px solid red",borderRadius: "10px"}}>
            <Col md={12}>
              <ParticipantLockedInfo
                participant={participants}
              ></ParticipantLockedInfo>
            </Col>
          </Row>}
          <Row>
            <Col md={6}>
              <ParticipantInfo participant={participants}></ParticipantInfo>
            </Col>
            <Col md={6}>
              {/* <Link className="text-right"  to={`/users/edit/${data.id}`}>Edit Participant</Link> */}
              <ParticipantCurrentPoints participant={participants} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ParticipantGoalPlans
                participant={participants}
              ></ParticipantGoalPlans>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ParticipantRewardHistory
                participant={participants}
              ></ParticipantRewardHistory>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <ParticipantAddress
                participant={participants}
                setRefreshUsers={setRefreshUsers}
              ></ParticipantAddress>
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <AddressModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        mode="add"
        onSave={handleSave}
       />
      <ModalWrapper
        name={modalName}
        isOpen={isActionOpen}
        setOpen={setActionOpen}
        toggle={toggle_modal}
        participants={participant}
        setRefreshUsers={setRefreshUsers}
      />
    </Modal>
  );
};
export default ParticipantViewModal;
